export function formatPercentage(percentage: number): string {
  return percentage.toFixed(1).replace('.0', '') + '%';
}

export function formatFraction(numerator: number, denominator: number): string {
  const formattedNumerator = parseFloat(numerator.toFixed(2)).toString();
  return `${formattedNumerator}/${denominator}`;
}
